export enum UserRole {
  User = 0,
  Moderator = 1,
  TenantAdmin = 2,
  POS = 3,
  Admin = 999,
}

export const UserRoleTranslations = {
  [UserRole.User]: 'users.user',
  [UserRole.Moderator]: 'users.moderator',
  [UserRole.TenantAdmin]: 'users.tenant_admin',
  [UserRole.POS]: 'users.pos',
  [UserRole.Admin]: 'users.admin',
};

export const UserRoleOptions = [
  { key: 'users.user', value: UserRole.User },
  { key: 'users.moderator', value: UserRole.Moderator },
  { key: 'users.tenant_admin', value: UserRole.TenantAdmin },
  { key: 'users.pos', value: UserRole.POS },
  { key: 'users.admin', value: UserRole.Admin },
];
